export default "__VITE_ASSET__DiSZnpoF__"